module.exports = __webpack_public_path__ + "img/uyuni.98b22952.jpg";